import { config } from 'components/config';
import { Social } from 'utils/enum';

const COOKIE_EXPIRED = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';
const COOKIE_PATH = 'path=/';

/** Default keys cleared when `clearShareCookies()` is called without arguments. */
export const CLEARED_COOKIES = ['provider'];

/** YouTube share-session cookies cleared when switching accounts or starting OAuth. */
export const YOUTUBE_SHARE_COOKIE_KEYS = [
  'mediaKeyYoutube',
  'provider',
  'access_token',
] as const;

export const clearYoutubeShareCookies = (): void => {
  clearShareCookies([...YOUTUBE_SHARE_COOKIE_KEYS]);
};

export const getShareCookieDomains = (): string[] => {
  const domains = new Set<string>([
    `.${config.DOMAIN_NAME}`,
    `.${window.location.host}`,
  ]);

  return Array.from(domains);
};

const clearCookie = (name: string, domain?: string): void => {
  if (domain) {
    window.document.cookie = `${name}=;${COOKIE_EXPIRED};${COOKIE_PATH};domain=${domain}`;
    return;
  }

  window.document.cookie = `${name}=;${COOKIE_EXPIRED};${COOKIE_PATH}`;
};

export const clearShareCookies = (keys?: string[]): void => {
  const names = keys?.length ? keys : [...CLEARED_COOKIES];
  const domains = getShareCookieDomains();

  names.forEach((name) => {
    clearCookie(name);
    domains.forEach((domain) => clearCookie(name, domain));
  });
};

export const getShareCookieDomain = (): string => `.${window.location.host}`;

export const setShareCookie = (name: string, value: string): void => {
  window.document.cookie = `${name}=${value};domain=${getShareCookieDomain()};${COOKIE_PATH}`;
};

export const setShareProviderCookie = (provider: Social): void => {
  clearShareCookies();
  setShareCookie('provider', provider);
};

export const setSharemediaKeyYoutubeCookie = (mediaKey: string): void => {
  clearShareCookies(['mediaKeyYoutube']);
  setShareCookie('mediaKeyYoutube', mediaKey);
};
